import { DocumentContent, RegulatoryBanner } from "@/src/components/ContentBlocks";
import { content } from "@/src/lib/content";

export default function RegulatoryPage() {
  return (
    <main id="main-content">
      <section className="student-page-hero shell"><p className="eyebrow">Single source of truth</p><h1>Regulatory timeline</h1><p>Use this page whenever course slides, worksheets, or assignments refer to EU AI Act implementation dates.</p></section>
      <section className="section shell public-document narrow-document"><RegulatoryBanner /><DocumentContent html={content.regulatoryHtml} /></section>
    </main>
  );
}
